<div class="timeline pt-2 mt-2 vd-timeline">
    <div class="row">
        <div class="col-md-2">
            <h6> <span class="pi pi-sitemap "></span> Timeline </h6>
        </div>
        <div class="col-md-10">
            <div class="ml-auto pb-3 pull-right">
                <div class="mr-3 float-left d-flex align-items-center">
                    <div class="float-left mr-2 legend completed"></div>
                    <div class="float-left"><span>Completed</span></div>
                </div>
                <div class="mr-3 float-left d-flex align-items-center">
                    <div class="float-left mr-2 legend submitted"></div>
                    <div class="float-left"><span>Submitted</span></div>
                </div>
                <div class="mr-3 float-left d-flex align-items-center">
                    <div class="float-left mr-2 legend inprogress"></div>
                    <div class="float-left"><span>In-Progress</span></div>
                </div>
                <div class="float-left d-flex align-items-center">
                    <div class="float-left mr-2 legend news"></div>
                    <div class="float-left"><span>New</span></div>
                </div>
            </div>
        </div>
    </div>
    <div class="container" style="width: 70%;">
        <div class="row timeline-row">
            <div class="col justify-content-center col-styled col-bene">
                <span class="time-title">
                    Beneficiary Actions
                </span>
            </div>
            <div class="col justify-content-center col-styled col-att">
                <span class="time-title">
                    Petitioner / Lawfirm Actions
                </span>
            </div>
        </div>
    </div>
    <div class="container timeline-action">
        <div class="row timeline-row">
            <div class="col justify-content-center"></div>
            <div class="col justify-content-center">
                <hr class="separator timeline-separator">
            </div>
            <div class="col justify-content-center"></div>
        </div>
    </div>
    <p-timeline [value]="stepList">
        <ng-template pTemplate="marker" let-step>
            <span class="custom-marker">
                <span class="new-icon"></span>
            </span>
        </ng-template>
        <ng-template pTemplate="content" let-step>
            <!-- Attorney / Petitioner Side -->
            <div class="d-inline-flex" *ngIf="step && step.actionNotifyFlag && (step?.actionNotifyFlag[0]?.isPetnrAtrnyActionable===1 || step?.actionNotifyFlag[0]?.isPetnrAtrnyActionable===true)">
                <hr class="separator">
                <div class=" p-shadow-2" class="new-border">
                    <button class="new">
                        {{ step?.stepName }}</button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="opposite" let-step>
            <!-- Beneficiary Side -->
            <div class="d-inline-flex" *ngIf="step && step.actionNotifyFlag && (step.actionNotifyFlag[1]?.isBeneficiaryActionable===1 || step?.actionNotifyFlag[1]?.isBeneficiaryActionable===true)">
                <div class="p-shadow-2" class="new-border-ben">
                    <button class="new">
                        {{ step?.stepName }}</button>
                </div>
                <hr class="separator">
            </div>
        </ng-template>
    </p-timeline>
</div>